var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelpQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 104.846,
    height: 86.24,
    viewBox: "0 0 104.846 86.24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_374",
    "data-name": "Group 374",
    transform: "translate(-290.573 -275.59)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_409",
    "data-name": "Path 409",
    d: "M191.7,225.338c.791,19.059,25.727,26.713,47.611,23.21,12.3-1.962,23.641-7.449,29.189-16.419a23.533,23.533,0,0,0,3.473-10.377C275.25,186.213,189.192,164.719,191.7,225.338Z",
    transform: "translate(159.936 50.097) rotate(13)",
    fill: "#003361",
    opacity: 0.287
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_405",
    "data-name": "Path 405",
    d: "M272.01,225.338c-.791,19.059-25.727,26.713-47.611,23.21-12.3-1.962-23.641-7.449-29.189-16.418a23.533,23.533,0,0,1-3.473-10.377C188.459,186.213,274.517,164.719,272.01,225.338Z",
    transform: "translate(123.355 112.458)",
    fill: "#fff",
    opacity: 0.287
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_402",
    "data-name": "Path 402",
    d: "M410.631,424.7a2.8,2.8,0,0,0,3.817,4.086c.047-.042.095-.083.14-.128a2.8,2.8,0,0,0-.906-4.566,2.832,2.832,0,0,0-1.072-.2A2.69,2.69,0,0,0,410.631,424.7Z",
    transform: "translate(-64.271 -94.721)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_403",
    "data-name": "Path 403",
    d: "M396.756,356.775a3.645,3.645,0,0,1,.681-1.884,1.682,1.682,0,0,1,1.377-.712,1.655,1.655,0,0,1,1.33.6,2.256,2.256,0,0,1,.507,1.5,2.223,2.223,0,0,1-.475,1.472l-2.153,2.216a8.4,8.4,0,0,0-1.409,1.757,4.424,4.424,0,0,0-.333,1.947v2.375h4.813v-1.9a2.885,2.885,0,0,1,.221-1.282,4.831,4.831,0,0,1,.9-1.092q.68-.665,1.44-1.425.158-.158.618-.7a4.327,4.327,0,0,0,.586-.807q.126-.269.443-.887a4.3,4.3,0,0,0,.317-1.884,5.611,5.611,0,0,0-1.852-4.464,7.791,7.791,0,0,0-9.736.19,6.689,6.689,0,0,0-1.339,1.724,8.652,8.652,0,0,0-.972,3.247Z",
    transform: "translate(-50.412 -38.144)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpQuestion);
export default __webpack_public_path__ + "static/media/help-question.68ee854abd2a4744a432c03f050275af.svg";
export { ForwardRef as ReactComponent };